import {
    UPC_SCAN_SAVE_REQUEST,
    UPC_SCAN_SAVE_SUCCESS,
    UPC_SCAN_SAVE_FAIL,
    UPC_SCAN_SAVE_RESET,

    UPC_SCAN_EXPORT_REQUEST,
    UPC_SCAN_EXPORT_SUCCESS,
    UPC_SCAN_EXPORT_FAIL,

    MY_UPC_SLIPS_REQUEST,
    MY_UPC_SLIPS_SUCCESS,
    MY_UPC_SLIPS_FAIL,


    EXPORT_UPC_EXCEL_REQUEST,
    EXPORT_UPC_EXCEL_SUCCESS,
    EXPORT_UPC_EXCEL_FAIL,


    CREATE_MAPPING_REQUEST,
    CREATE_MAPPING_SUCCESS,
    CREATE_MAPPING_FAIL,
    CREATE_MAPPING_RESET,

    ALL_MAPPINGS_REQUEST,
    ALL_MAPPINGS_SUCCESS,
    ALL_MAPPINGS_FAIL,

    UPDATE_MAPPING_REQUEST,
    UPDATE_MAPPING_SUCCESS,
    UPDATE_MAPPING_FAIL,
    UPDATE_MAPPING_RESET,

    DELETE_MAPPING_REQUEST,
    DELETE_MAPPING_SUCCESS,
    DELETE_MAPPING_FAIL,
    DELETE_MAPPING_RESET,

    CLEAR_ERRORS
} from "../constants/upcScanConstants";

export const upcScanReducer = (state = {}, action) => {
    switch (action.type) {
        case UPC_SCAN_SAVE_REQUEST:
        case UPC_SCAN_EXPORT_REQUEST:
            return {
                ...state,
                loading: true
            };

        case UPC_SCAN_SAVE_SUCCESS:
            return {
                loading: false,
                success: true,
                message: action.payload
            };

        case UPC_SCAN_EXPORT_SUCCESS:
            return {
                loading: false
            };

        case UPC_SCAN_SAVE_FAIL:
        case UPC_SCAN_EXPORT_FAIL:
            return {
                loading: false,
                error: action.payload
            };

        case UPC_SCAN_SAVE_RESET:
            return {};

        case CLEAR_ERRORS:
            return {
                ...state,
                error: null
            };

        default:
            return state;
    }
};

const initialState = {
    loading: false,
    slips: [],
    totalPages: 1,
    currentPage: 1,
};

export const myUpcSlipsReducer = (state = initialState, action) => {
    switch (action.type) {

        case MY_UPC_SLIPS_REQUEST:
            return {
                ...state,          // ✅ keep slips
                loading: true,
            };

        case MY_UPC_SLIPS_SUCCESS:
            return {
                loading: false,
                slips: action.payload.slips || [],   // ✅ ARRAY ONLY
                totalPages: action.payload.totalPages || 1,
                currentPage: action.payload.currentPage || 1,
            };

        case MY_UPC_SLIPS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
            };

        default:
            return state;
    }
};
const initialStateMapping = {
    loading: false,
    mappings: [],
};

export const myMappingsReducer = (state = initialStateMapping, action) => {
    switch (action.type) {

        case ALL_MAPPINGS_REQUEST:
            return {
                ...state,          // ✅ keep slips
                loading: true,
            };

        case ALL_MAPPINGS_SUCCESS:
            return {
                loading: false,
                mappings: action.payload.mappings || [],   // ✅ ARRAY ONLY
            };

        case ALL_MAPPINGS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
            };

        default:
            return state;
    }
};

export const exportUpcExcelReducer = (state = {}, action) => {
    switch (action.type) {
        case EXPORT_UPC_EXCEL_REQUEST:
            return { loading: true };

        case EXPORT_UPC_EXCEL_SUCCESS:
            return { loading: false, success: true };

        case EXPORT_UPC_EXCEL_FAIL:
            return { loading: false, error: action.payload };

        default:
            return state;
    }
};


export const mappingReducer = (state = {}, action) => {
    switch (action.type) {
        case CREATE_MAPPING_REQUEST:
        case UPDATE_MAPPING_REQUEST:
        case DELETE_MAPPING_REQUEST:
            return {
                ...state,
                loading: true
            };

        case CREATE_MAPPING_SUCCESS:
        case UPDATE_MAPPING_SUCCESS:
        case DELETE_MAPPING_SUCCESS:
            return {
                loading: false,
                success: true,
                message: action.payload
            };



        case CREATE_MAPPING_FAIL:
        case UPDATE_MAPPING_FAIL:
        case DELETE_MAPPING_FAIL:
            return {
                loading: false,
                error: action.payload
            };

        case CREATE_MAPPING_RESET:
        case UPDATE_MAPPING_RESET:
        case DELETE_MAPPING_RESET:
            return {};

        case CLEAR_ERRORS:
            return {
                ...state,
                error: null
            };

        default:
            return state;
    }
};